import React from 'react';
import PropTypes from 'prop-types';
import { Alert, PageHeader } from 'react-bootstrap';

const Error = ({ message }) => {
  const errorMessagge = typeof(message) === 'object' && (message.message) ? message.message : message
  return (    
    <div>
      <PageHeader>Error</PageHeader>
      <Alert bsStyle="danger">
        <h4>Oh snap! You got an error!</h4>
        <p>{errorMessagge || 'No additional error information available'}</p>
      </Alert>
    </div>
  )
}

Error.propTypes = {
  message: PropTypes.any
};

export default Error



// WEBPACK FOOTER //
// ./src/components/error/Error.js